import { render } from "./TrafficStatisticView.vue?vue&type=template&id=36046a01&scoped=true"
import script from "./TrafficStatisticView.vue?vue&type=script&lang=js"
export * from "./TrafficStatisticView.vue?vue&type=script&lang=js"

import "./TrafficStatisticView.vue?vue&type=style&index=0&id=36046a01&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36046a01"]])

export default __exports__